import { render, staticRenderFns } from "./SoftwareHome.vue?vue&type=template&id=7c4c2fac&scoped=true&"
import script from "./SoftwareHome.vue?vue&type=script&lang=js&"
export * from "./SoftwareHome.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareHome.vue?vue&type=style&index=0&id=7c4c2fac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4c2fac",
  null
  
)

export default component.exports